import { defineStyleConfig } from '@chakra-ui/react'
import type { StyleFunctionProps } from '@chakra-ui/styled-system'

const Button = defineStyleConfig({
  baseStyle: {
  },
  sizes: {
    md: {
      label: {
        fontSize: "11px",
        lineHeight: "14px",
        mb: "10px"
      },
      number: {
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "16px"
      }
    }
  },
  variants: {
    primary: (props: StyleFunctionProps) => ({
      label: {
        color: props.colorMode === "light" ? "navy" : "white",
      },
      number: {
        color: props.colorMode === "light" ? "navy" : "white",
      }
    })
  },
  defaultProps: {
    variant: "primary",
    size: "md"
  }
})
export default Button